import {Component, Input, Output, EventEmitter} from '@angular/core'
import {PannellumStadiumCamera} from 'app/models/pannellum-stadium-camera'

@Component({
    selector: 'app-camera-selector',
    templateUrl: './camera-selector.component.html',
    styleUrls: ['./camera-selector.component.scss'],
})
export class CameraSelectorComponent {

    constructor() {}

    @Input() cameras: PannellumStadiumCamera
    @Input() currentCamera: PannellumStadiumCamera
    @Output() onSelectCamera = new EventEmitter<PannellumStadiumCamera>()

    selectCamera(camera: PannellumStadiumCamera) {
        this.onSelectCamera.emit(camera)
    }
}
